<div class="body-container-all">

    <mat-tab-group [selectedIndex]="selectedTab" (selectedIndexChange)="changeTab($event)">
        <mat-tab label="Afegir">
            <ng-container *ngTemplateOutlet="fbAddTools"></ng-container>
        </mat-tab>
        
        <mat-tab label="Editar">
            <ng-container *ngTemplateOutlet="fbEditDetail"></ng-container>
        </mat-tab>
    </mat-tab-group>


    <ng-template #fbAddTools>
        
        <app-page-scroll-content>
            <app-tool-help>
                <mat-icon class="material-icons-outlined" style="overflow: visible;" helpIcon>pan_tool_alt</mat-icon>
                <div helpDesc>Arrossega un camp a l'espai de la dreta i comença a crear la secció formulari.</div>
            </app-tool-help>

            <mat-accordion displayMode="flat" [multi]="true">

                <mat-expansion-panel [expanded]="true" class="mat-elevation-z81">

                    <mat-expansion-panel-header>
                        <mat-panel-description class="mat-body-2" style="color:unset">
                            Camps estàndard
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div id="tools" cdkDropList [cdkDropListData]="tools" cdkDropListSortingDisabled
                        [cdkDropListEnterPredicate]="neverEnterPredicate" class="d-flex flex-wrap" style="gap:16px;">

                        <div class="tool-box d-flex flex-column align-items-center justify-content-center"
                            *ngFor="let widget of tools.widgets" (cdkDragStarted)="startDD($event,widget)"
                            (click)="addWidget(widget)"
                            (cdkDragEnded)="endDD($event)" [cdkDragData]="{type:'tool',id:widget.id(),layout:false}"
                            cdkDrag>

                            <div>
                                <mat-icon class="material-icons-outlined">{{widget?.icon()}}</mat-icon>
                            </div>
                            <div>{{widget?.name()}}</div>

                            <ng-template cdkDragPreview matchSize="true">
                                <ng-container [ngTemplateOutlet]="widgetDDPreview"
                                    [ngTemplateOutletContext]="{data:{widget:widget}}">
                                </ng-container>
                            </ng-template>
                        </div>

                        <div class="tool-box d-flex flex-column align-items-center justify-content-center"
                            *ngFor="let layoutTool of layoutTools" [cdkDragData]="{type:'tool',id:layoutTool.name(),layout:true}" 
                            (cdkDragStarted)="removeSelection($event)" (click)="addWidget(layoutTool)"
                            cdkDrag>

                            <div>
                                <mat-icon class="material-icons-outlined">{{layoutTool.icon()}}</mat-icon>
                            </div>
                            <div>{{layoutTool.label()}}</div>

                            <ng-template cdkDragPreview matchSize="true">
                                <ng-container [ngTemplateOutlet]="widgetDDPreview"
                                    [ngTemplateOutletContext]="{data:{widget:layoutTool}}">
                                </ng-container>
                            </ng-template>
                        </div>

                    </div>


                </mat-expansion-panel>

            </mat-accordion>

        </app-page-scroll-content>

    </ng-template>

    <ng-template #fbEditDetail>
    
        <app-page-scroll-content>

            <div *ngIf="detailType == 'none'">
                <app-tool-help>
                    <mat-icon class="material-icons-outlined" style="overflow: visible;" helpIcon>visibility</mat-icon>
                    <div helpDesc>Selecciona un objecte per mostrar les seves opcions de configuració</div>
                </app-tool-help>
            </div>

            <ng-container [ngSwitch]="detailType">
                <ng-container *ngSwitchCase="'section'">
                    <app-section-metadata-editor [item]="section" (changeItem)="onFireChange($event)" >

                    </app-section-metadata-editor>    
                </ng-container>
                
                <ng-container *ngSwitchCase="'layout'">
                    <app-layout-metadata-editor [item]="layout" (changeItem)="onFireChange($event)"
                        (goParent)="onGoParentLayout()">

                    </app-layout-metadata-editor>
                </ng-container>
                
                <ng-container *ngSwitchCase="'item'">
                    <app-item-metadata-editor *ngIf="item" #itemRef [anItem]="item" (changeItem)="onFireChange($event)"
                        (goParent)="onGoParentWidget()">

                    </app-item-metadata-editor>
                </ng-container>

            </ng-container>

        </app-page-scroll-content>

    </ng-template>

<ng-template #widgetDDPreview let-data="data">
    <div class="d-flex flex-column justify-content-center align-items-center widget-dd-preview mat-elevation-z4">                
        <mat-icon>{{data.widget?.icon()}}</mat-icon>
        <div>{{data.widget?.name()}}</div>
    </div>
</ng-template>